import { createContext } from 'react';
const initialChannelContextValues = {
    updateChannel: null
};
const ChannelContext = createContext(initialChannelContextValues);
export default ChannelContext;
//# sourceMappingURL=ChannelContext.js.map